module.exports = __webpack_public_path__ + "checkExpiredTimeWorker.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/assets/checkExpiredTimeWorker.js
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/assets/checkExpiredTimeWorker.js
// module chunks = 7